
import showdown from "showdown" 

export default function(o, done){

  var userLabel = o.util.getTranslation(o, 'email')
  var passwordLabel = o.util.getTranslation(o, 'password')

  var passwordResetConfirmLabel = o.util.getTranslation(o, 'passwordResetConfirm')
  var passwordResetLabel = o.util.getTranslation(o, 'passwordReset')
  var passwordRepeatLabel = o.util.getTranslation(o, 'passwordRepeat')
  
  var loginLabel = o.util.getTranslation(o, 'login')
  var logoutLabel = o.util.getTranslation(o, 'logout')
  var adminLabel = o.util.getTranslation(o, 'admin')

  document.title = `Open Memory Box | ${loginLabel}`

  var lang = o.store('lang')

  var converter = new showdown.Converter({
    simpleLineBreaks: true,
    openLinksInNewWindow: true,
  })

  o.data.content(o, function(contentData){

    var logoutClick = function(){
      o.store.remove('token')
      o.store.remove('role')
      o.store.remove('email')
      o.render(o)
    }

    var adminClick = function(){
      window.open('/admin','_self')
    }

    var loginClick = function(){
      var credentials = {
        email: userInput.val(),
        password: passwordInput.val(),
      }
      o.util.login(o, credentials, function(error, data){
        if(error && error.error == 'email and passsword required'){
          errorDiv.html(o.util.getTranslation(o,'loginEmpty'))
        } else if(error && error.error == 'email not found'){
          errorDiv.html(o.util.getTranslation(o,'loginInvalid'))
        } else if(error && error.error == 'invalid password'){
          errorDiv.html(o.util.getTranslation(o,'loginInvalid'))
        } else if(data && data.token && data.role) {
          errorDiv.empty()
          o.store('token', data.token)
          o.store('role', data.role)
          o.store('email', credentials.email)
          o.render(o)
        } else {
          errorDiv.html(o.util.getTranslation(o,'serverError'))
        }
      })
    }

    var resetClick = function(){
      console.log('reset password')
      var p1 = passwordResetInput.val()
      var p2 = passwordRepeatInput.val()
      if(!p1 || !p2 || p1 != p2){
        errorDiv.html(o.util.getTranslation(o,'passwordResetError'))
      } else {
        o.util.resetPassword(o, p1, function(error, data){
          if(error){
            errorDiv.html(o.util.getTranslation(o,'serverError'))
          } else {
            o.store.remove('token')
            o.store.remove('role')
            o.store.remove('email')
            o.render(o)
          }
        })
      }
    }

    var loginContent = _.find(contentData, {view: 'login'})
    var loginMarkdown = loginContent[lang]
    var loginHtml = converter.makeHtml(loginMarkdown)

    var loginTextDiv =
      $('<div>')
      .css({
        textTransform: 'none',
        marginTop: '1.3rem',
      })
      .html(loginHtml)
      
    var logoutContent = _.find(contentData, {view: 'logout'})
    var logoutMarkdown = logoutContent[lang]
    var logoutHtml = converter.makeHtml(logoutMarkdown)
  
    var logoutTextDiv =
      $('<div>')
      .css({
        textTransform: 'none',
        marginTop: '1.3rem',
      })
      .html(logoutHtml)

    var userDiv =
      $('<div>')
      .css({
        marginBottom: '0.2rem',
      })
      .html(userLabel)

    var userInput =
      o.component.input(o,true)
      .css({
        display: 'block',
        width: '15rem',
        maxWidth: '90%',
        margin: '0 auto',
        marginBottom: '0.4em',
      })
      .keyup(function(e) {
        if (e.keyCode === 13) {
            loginClick()
        }
      })

    var passwordDiv =
      $('<div>')
      .css({
        marginBottom: '0.2rem',
      })
      .html(passwordLabel)

    var passwordInput =
      o.component.input(o,true)
      .attr({
        type: 'password',
      })
      .css({
        display: 'block',
        width: '15rem',
        maxWidth: '90%',
        margin: '0 auto',
        marginBottom: '0.05em',
      })
      .keyup(function(e) {
        if (e.keyCode === 13) {
            loginClick()
        }
      })

    var passwordResetDiv =
      $('<div>')
      .css({
        marginBottom: '0.2rem',
        marginTop: '2rem',
      })
      .html(passwordResetLabel)

    var passwordResetInput =
      o.component.input(o,true)
      .attr({
        type: 'password',
      })
      .css({
        display: 'block',
        width: '15rem',
        maxWidth: '90%',
        margin: '0 auto',
        marginBottom: '0.4em',
      })
      .keyup(function(e) {
        if (e.keyCode === 13) {
          resetClick()
        }
      })

    var passworRepeatdDiv =
      $('<div>')
      .css({
        marginBottom: '0.2rem',
      })
      .html(passwordRepeatLabel)

    var passwordRepeatInput =
      o.component.input(o,true)
      .attr({
        type: 'password',
      })
      .css({
        display: 'block',
        width: '15rem',
        maxWidth: '90%',
        margin: '0 auto',
        marginBottom: '0.05em',
      })
      .keyup(function(e) {
        if (e.keyCode === 13) {
          resetClick()
        }
      })

    var loginButtonDiv = o.component.button(o, loginLabel, loginClick)
    var logoutButtonDiv = o.component.button(o, logoutLabel, logoutClick)
    var adminButtonDiv = o.component.button(o, adminLabel, adminClick)
    var resetButtonDiv = o.component.button(o, passwordResetConfirmLabel, resetClick)

    var errorDiv =
      $('<div>')
      .css({
        color: o.colors.red,
        textTransform: 'none',
        marginBottom: '1.2em',
        marginTop: '-0.2rem',
      })
      .html('&nbsp;')

    var logoutButtonsDiv = $('<div>')
    .append([
      logoutButtonDiv
      .css({
        margin: '0.1rem 0.25rem',
      }),
    ])

    var logoutDiv =
      $('<div>')
      .css(o.morePagesTextCss)
      .append([
        logoutTextDiv,
        logoutButtonsDiv,
      ])

    var loginDiv =
      $('<div>')
      .css(o.morePagesTextCss)
      .append([
        userDiv,
        userInput,
        passwordDiv,
        passwordInput,
        loginButtonDiv
        .css({
          margin: '0.25rem'
        }),
        errorDiv,
        loginTextDiv,
      ])

    if(o.store('token')){

      var mainDiv = 
        $('<div>')
        .css({
          flex: '0 1 auto',
          justifyContent: 'center',
          overflowY: 'auto',
          '-webkit-overflow-scrolling': 'touch',
          minHeight: 0,
          zIndex: 1,
        })
        .append([
          logoutDiv,
        ])
  
      if(o.store('role') == 'admin' || o.store('role') == 'author'){
        logoutButtonsDiv.append([
          o.component.spacer(o)
          .css({
            margin: '0.1rem 0.25rem'
          }),
          adminButtonDiv
          .css({
            margin: '0.1rem 0.25rem'
          }),
        ])
      }

      logoutDiv
      .append([
        passwordResetDiv,
        passwordResetInput,
        passworRepeatdDiv,
        passwordRepeatInput,
        resetButtonDiv,
        errorDiv,
      ])

    } else {
      var mainDiv = 
        $('<div>')
        .css({
          flex: '0 1 auto',
          justifyContent: 'center',
          overflowY: 'auto',
          '-webkit-overflow-scrolling': 'touch',
          minHeight: 0,
          zIndex: 1,
        })
        .append([
          loginDiv,
        ])
    }

    var div = $('<div>')
    .css(o.mainDivCss)
    .addClass('iphoneNavbarFixTop')
    .addClass('iphoneNavbarFixBottom')  
    .append([

      o.component.menu(o)
      .css({
        flex: '0 0 auto',
        width: '100%',
        zIndex: 1,
      }),

      $('<div>')
      .css({
        flex: '1 1 auto',
      }),

      mainDiv,

      $('<div>')
      .css({
        flex: '1 1 auto',
      }),

    ])

    var observer =
      new MutationObserver(function(){
        if (document.body.contains(div[0])){

          observer.disconnect()

          userInput.focus()

        }
      })

    observer.observe(document.body, {childList: true});

    done(div)

  })

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/login/login.js